import React from 'react';
import GradientButton from '../../../components/atoms/GradientButton';

const TelehealthServiceQuestions = () => {
  return (
    <div className=" w-ful max-w-[1200px] mx-auto px-4 my-10 text-center">
      <p className="text-[#6B3FA0] text-lg md:text-xl xl:text-[28px] 2xl:text-[32px] font-semibold mb-8">
        If you’re interested in learning more about our Telehealth services or
        have any questions,
      </p>

      <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-14 my-14">
        <GradientButton
          text="Contact us Today"
          width="w-full md:w-[240px]"
          navigateTo={'/contact'}
        />
      </div>

      <h2 className="text-[#6B3FA0] text-xl lg:text-[38px] 2xl:text-[50px] font-bold leading-normal">
        Effective telehealth from our trained professionals will get your child
        back on track.
      </h2>
    </div>
  );
};

export default TelehealthServiceQuestions;
